import { cardPrefixCls } from "@/base/components/card/Card.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Card">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${cardPrefixCls}`]: {
      [`.${cardPrefixCls}-head`]: {
        paddingBlock: 12,
      },
    },
  },
});

export const useCardStyle = genComponentStyleHook(["Card", "cso"], (token) => {
  return [genStyle(token)];
});
